import { format } from 'date-fns';

export const dateFormatter = (date: Date) => {
  return format(new Date(date), 'dd/MM');
};

export const dateFormatterWithPattern = (date: Date, formatType?: string) => {
  return format(new Date(date), formatType ?? 'MMM d');
};
